import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AuthenticationService } from "../services/authentication.service";
import { Signin } from "../services/signin";
import { EditStateComponent } from "app/shared/edit-state.component";

@Component({
  selector: "app-dashboard",
  templateUrl: "./full-layout.component.html",
})
export class FullLayoutComponent extends Signin implements OnInit {
  public isAdministrator: boolean = false;
  public isEntryUser: boolean = false;
  public isOverviewUser: boolean = false;

  constructor(
    public router: Router,
    public authenticationService: AuthenticationService,
    private editState: EditStateComponent
  ) {
    super(router, authenticationService);
  }

  public checkUserRoleAndSetVisibility(): void {
    var user = this.authenticationService.getUser().subscribe((res) => {
      //console.log(res);
      if (res.role === "administrator") {
        this.isAdministrator = true;
        this.isEntryUser = true;
        this.isOverviewUser = true;
      }
      if (res.role === "indtastning") {
        this.isEntryUser = true;
      }
      if (res.role === "overblik") {
        this.isOverviewUser = true;
      }
      if (res.role === "indtastning og overblik") {
        this.isOverviewUser = true;
        this.isEntryUser = true;
      }
    });
  }

  public disabled: boolean = false;

  public status: { isopen: boolean } = { isopen: false };

  public toggled(open: boolean): void {
    console.log("Dropdown is now: ", open);
  }

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  confirmNavigation(event: MouseEvent, targetRoute: string): void {
    event.preventDefault(); // Prevent default link behavior

    if (this.editState.getEditMode()) {
      const confirmLeave = confirm(
        "Du har foretaget ændringer. Er du sikker på, at du vil forlade siden uden at gemme?"
      );
      if (confirmLeave) {
        this.editState.setEditMode(false);
        this.router.navigate([targetRoute]); // Navigate programmatically
      }
    } else {
      this.router.navigate([targetRoute]); // Navigate if no edits
    }
  }

  ngOnInit(): void {
    this.checkUserRoleAndSetVisibility();
  }
}
